import React, { Component } from 'react'
import { HeaderView } from '@merchant-backend/common-components'
import Store from './store'
import { observer } from 'mobx-react'
import style from './style.module.less'
import {
  PRIVILEGE_STORE_ID,
  PRIVILEGE_STORE_SERVICE_ID,
  PUBLISH_CASE_PATH_A
} from '@constant'
import cls from 'classnames'
import { Auth } from '@common/Auth'

class Property extends Component {
  onClick = () => {
    window.location.href = `${PUBLISH_CASE_PATH_A}?propertyId=${this.props.id}`
  }

  render() {
    const { name, image } = this.props

    return (
      <div className={style.item} onClick={this.onClick}>
        <img src={image} />
        <p>{name}</p>
      </div>
    )
  }
}

@Auth({ role: [PRIVILEGE_STORE_ID, PRIVILEGE_STORE_SERVICE_ID] })
@observer
export default class extends Component {
  constructor(props) {
    super(props)

    this.store = new Store(1)
  }

  componentDidMount() {
    this.store.getPropertyList()
  }

  render() {
    const { propertyList } = this.store

    return (
      <HeaderView title="发布案例">
        <div className={style.header}>选择类目</div>
        <div className={cls('clearfix', style.list)}>
          {propertyList.map(item => <Property key={item.id} {...item} />)}
        </div>
      </HeaderView>
    )
  }
}
